import { OppgaveStatus } from "../enums/oppgaveStatus";
import { OppgaveType } from "../enums/oppgaveType";

import type { Oppgave } from "../types/oppgave";

import { leggTilEnDag } from "../utils/leggTilEnDag";

export const erEksternOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return oppgave?.Type === OppgaveType.Ekstern;
};

export const erVerktoyOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return oppgave?.Type === OppgaveType.Verktoy;
};

export const erInformasjonOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return oppgave?.Type === OppgaveType.Informasjon;
};

export const erSamtykkeOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return oppgave?.Type === OppgaveType.Samtykke;
};

export const erSkjemaOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return oppgave?.Type === OppgaveType.Skjema;
};

export const erBetalingsOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return oppgave?.Type === OppgaveType.Betaling;
};

export const kanVisesInfoKnapp = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return (
    !!oppgave &&
    erInformasjonOppgave(oppgave) &&
    (oppgave.Status === OppgaveStatus.Ready ||
      oppgave.Status === OppgaveStatus.InProgress ||
      oppgave.Status === OppgaveStatus.Completed)
  );
};

export const kanUtforeOppgave = (
  oppgave?: Oppgave | null | undefined,
): boolean => {
  return kanBesvares(oppgave) && erInformasjonOppgave(oppgave);
};

export const kanBesvares = (oppgave?: Oppgave | null | undefined): boolean => {
  return (
    !!oppgave &&
    leggTilEnDag(oppgave.GyldigTilDato) >= new Date() &&
    (oppgave.Status === OppgaveStatus.Ready ||
      oppgave.Status === OppgaveStatus.InProgress)
  );
};
